// client/src/api/ApiReferrals.js
/**
 * API client for referral code operations
 *
 * Referral codes allow existing users to invite new users and track signups.
 * Codes must be validated before use to prevent invalid/expired codes from
 * being submitted during account creation.
 */
import flex from './FlexFetch'

const referralEndpoint = '/api/1.0/referrals/'

/**
 * Validate a referral code
 * @param {string} code - Referral code to validate
 * @returns {Promise<{valid: boolean, code: string}>}
 */
async function validateReferralCode(code) {
  const response = await flex.flexFetch(
    referralEndpoint + `validate/${encodeURIComponent(code)}`,
    {
      credentials: 'include',
    },
  )
  const payload = await flex.handleResponse(response)
  return payload?.success === true ? payload.data : payload
}

/**
 * Get my referral code
 * @returns {Promise<{hasCode: boolean, referralCode: object|null, stats: object}>}
 */
async function getMyCode() {
  const response = await flex.flexFetch(referralEndpoint + 'my-code', {
    credentials: 'include',
  })
  const payload = await flex.handleResponse(response)
  return payload?.success === true ? payload.data : payload
}

/**
 * Get list of people I referred
 * @returns {Promise<{referrals: Array}>}
 */
async function getMyReferrals() {
  const response = await flex.flexFetch(referralEndpoint + 'my-referrals', {
    credentials: 'include',
  })
  const payload = await flex.handleResponse(response)
  return payload?.success === true ? payload.data : payload
}

const ApiReferrals = {
  validateReferralCode,
  getMyCode,
  getMyReferrals,
}

export default ApiReferrals
